export default {
  FlightNumbers__FLIGHT_INFORMATION_ARIA_LABEL: (data) =>
    `Information for flight ${data.flightCount > 1 ? "numbers" : "number"}${
      data.airlineCode ? ` ${data.AIRLINE_CODE}` : ""
    } ${data.flightNumberContent}.`,
};
